<template>
  <section>
    <slot v-if="$slots.header" name="header" />
    <main
      class="content"
      ref="main"
      :style="{ 'height': `calc(100vh - ${offset}px)` }"
      @scroll="debouncedScroll"
    >
      <slot />
    </main>
    <slot v-if="$slots.footer" name="footer" />
  </section>
</template>

<script>
import { debounce } from '@/utils/utils'

export default {
  name: 'LayoutWithScrollbar',
  props: {
    debounceTime: {
      type: Number,
      default: 100,
    },
    scrollOffset: {
      type: Number,
      default: 200,
    },
  },
  data() {
    return {
      offset: 0,
    };
  },
  methods: {
    handleScroll(e) {
      const { clientHeight, scrollHeight, scrollTop } = e.target
      if (scrollHeight - clientHeight - scrollTop < this.scrollOffset) {
        this.$emit('scrollEnd')
      }
    },
    setOffset() {
      const main = this.$refs?.main;
      const top = main?.getBoundingClientRect()?.top || 0;
      const height = main?.nextElementSibling?.getBoundingClientRect().height || 0;
      this.offset = top + height;
    },
  },
  created() {
    this.debouncedScroll = debounce(this.handleScroll, this.debounceTime)
  },
  mounted() {
    this.setOffset();
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scroll-behavior: smooth;
}
</style>
